import { combineReducers } from 'redux';
import { pathOr, uniq } from 'ramda';
import memoize from 'lodash.memoize';

import { actions } from '../actions/categories';
import { createSelector } from 'reselect';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actions.FETCH_CATEGORIES_SUCCESS:
    case actions.FETCH_CATEGORY_SUCCESS:
      return Object.assign({}, state, pathOr({}, ['payload', 'entities', 'categories'], action));
    default:
      return state;
  }
};

const ids = (state = [], action) => {
  switch (action.type) {
    case actions.FETCH_CATEGORIES_SUCCESS:
      return uniq(Object.assign([], state, pathOr([], ['payload', 'result'], action)));
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case actions.FETCH_CATEGORIES_REQUEST:
    case actions.FETCH_CATEGORY_REQUEST:
    case actions.CREATE_CATEGORY_REQUEST:
    case actions.UPDATE_CATEGORY_REQUEST:
      return true;
    case actions.FETCH_CATEGORIES_SUCCESS:
    case actions.FETCH_CATEGORIES_FAILED:
    case actions.FETCH_CATEGORY_SUCCESS:
    case actions.FETCH_CATEGORY_FAILED:
    case actions.CREATE_CATEGORY_SUCCESS:
    case actions.CREATE_CATEGORY_FAILED:
    case actions.UPDATE_CATEGORY_SUCCESS:
    case actions.UPDATE_CATEGORY_FAILED:
      return false;
    default:
      return state;
  }
};

const categories = combineReducers({
  byId,
  ids,
  loading,
});

export default categories;

const categoriesIdsSelector = state => state.categories.ids;
const categoriesByIdSelector = state => state.categories.byId;
export const loadingSelector = state => state.categories.loading;

export const categoriesSelector = createSelector(
  categoriesIdsSelector, categoriesByIdSelector,
  (ids, categoriesById) => ids.map(id => categoriesById[id])
);

export const categoriesSubsetSelector = createSelector(
  categoriesByIdSelector,
  categoriesById => memoize(
    ids => ids.map(id => categoriesById[id])
  )
);

export const categorySelector = createSelector(
  categoriesByIdSelector,
  categoriesById => memoize(
    id => categoriesById[id]
  )
);
